import baseTheme from '../baseTheme';
var MuiAutocomplete = {
    /* your custom class style overrides here */
    inputRoot: {
        // "&&" just increases specificity so it overrides equivalent internal MUI rules
        // regardless of CSS insertion order
        '&&[class*="MuiOutlinedInput-root"] $input': {
            // these are designed to equate to the total padding of a normal input,
            // once you factor out the 8px of padding for the outer autocomplete box.
            // The 8px padding is useful because in a multi-select scenario, we want
            // the pills to not rub up against the borders.
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 10,
            paddingRight: 10,
        },
        '&&[class*="MuiOutlinedInput-marginDense"]': {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
    input: {},
    paper: {
        borderWidth: '2px',
        borderRadius: baseTheme.shape.borderRadius,
        borderColor: baseTheme.palette.grey[500],
        fontSize: baseTheme.typography.pxToRem(14),
    },
    listbox: {
        padding: 0,
    },
    tag: {
        backgroundColor: baseTheme.palette.background.paper,
        borderWidth: 1,
        borderColor: baseTheme.palette.grey[500],
        borderStyle: 'solid',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: baseTheme.palette.primary.light,
        },
        '& svg': {
            color: baseTheme.palette.text.primary,
            borderTopRightRadius: baseTheme.shape.borderRadius,
            borderBottomRightRadius: baseTheme.shape.borderRadius,
            padding: baseTheme.spacing(0.25),
            height: '100%',
            marginRight: 0,
            marginLeft: baseTheme.spacing(0.125),
        },
        '&:hover svg': {
            // specialized color because opacity messes up the stroke color
            backgroundColor: '#c7e2e9',
        },
    },
    option: {
        '& + &': {
            borderTopWidth: 1,
            borderTopStyle: 'solid',
            borderTopColor: baseTheme.palette.grey[300],
        },
    },
    groupLabel: {
        padding: baseTheme.spacing(0.5) + "px " + baseTheme.spacing(2) + "px",
        lineHeight: 1.5,
        top: 0,
        margin: 0,
        backgroundColor: baseTheme.palette.grey[100],
        fontWeight: 700,
        borderBottom: "1px solid " + baseTheme.palette.grey[300],
        borderTop: "1px solid " + baseTheme.palette.grey[300],
    },
    popupIndicator: {
        padding: baseTheme.spacing(1),
        color: 'inherit',
        transition: baseTheme.transitions.create('transform'),
    },
    clearIndicator: {
        marginRight: baseTheme.spacing(0.5),
    },
};
export default MuiAutocomplete;
//# sourceMappingURL=MuiAutocomplete.js.map